
import {Vue, Component, Prop, Watch} from 'vue-property-decorator';

@Component({})
export default class DictJurnal extends Vue {
    @Prop() selectedDict!: string;
    uploadLogLoading = false;
    uploadLogPerPage = 10;
    uploadLogCurrentPage = 1;
    uploadLogSortBy = 'loadDateTime';
    uploadLogSortDesc = true;
    uploadLogTotalRows = 0;
    showLogDetailsModal = false;
    logDetailsLoading = false;
    logDetailsData: any = null;
    uploadLogFields = [
        { key: 'id', label: 'ID', sortable: true },
        { key: 'target_table', label: 'СПРАВОЧНИК/ТАБЛИЦА', sortable: true },
        { key: 'update_time', label: 'ДАТА И ВРЕМЯ ЗАГРУЗКИ', sortable: true },
        { key: 'status', label: 'СТАТУС ЗАГРУЗКИ', sortable: true },
        { key: 'user_name', label: 'ПОЛЬЗОВАТЕЛЬ', sortable: true },
        { key: 'detail', label: 'ДЕТАЛИЗАЦИЯ', sortable: false },
        { key: 'export', label: 'ВЫГРУЗКА', sortable: false },
        { key: 'start_type', label: 'ВИД ЗАПУСКА', sortable: true }
    ]

    changesDetailsFields = [
        { key: 'changeType', label: 'Тип изменения', sortable: true },
        { key: 'code', label: 'Код записи', sortable: true },
        { key: 'field', label: 'Поле', sortable: true },
        { key: 'oldValue', label: 'Старое значение', sortable: false },
        { key: 'newValue', label: 'Новое значение', sortable: false }
    ]

    @Watch("selectedDict")
    async onChangeSelectedDict(value: string, oldValue: string) {
        this.loadUploadLog();
    }

    mounted() {
        console.log("Mounted");
        this.loadUploadLog();
    }

    uploadLogItems = [];

    // Маппинг справочников на API endpoints
    getDictApiName(dictName: string): string | null {
        const dictMapping: { [key: string]: string } = {
            'gu': 'GU',
            'dict_ebk_doh': 'KPB',
            'dict_budget_regions': 'TPK',
            'dict_ebk_ek': 'EKR',
            'ebk_func_types': 'FKR'
        };
        return dictMapping[dictName] || null;
    }

    async downloadChangesFile(logId: number | string) {
        if (logId == null) return;
        try {
            const url = `/api/integration/dict/log/${logId}/changes_file`;
            const response = await fetch(url);
            if (!response.ok) {
                const text = await response.text();
                console.error('Скачивание файла выгрузки:', response.status, response.statusText, text);
                alert(`Не удалось скачать файл. Ответ сервера: ${response.status} ${response.statusText}.`);
                return;
            }
            const blob = await response.blob();
            const disposition = response.headers.get('Content-Disposition');
            const fileNameMatch = disposition && disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            const fileName = fileNameMatch ? fileNameMatch[1].replace(/['"]/g, '').trim() : `changes_${logId}.xlsx`;
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(a.href);
        } catch (error) {
            console.error('Ошибка скачивания файла выгрузки:', error);
            alert('Не удалось скачать файл.');
        }
    }

    async loadUploadLog() {
        const apiDictName = this.getDictApiName(this.selectedDict);
        
        if (!apiDictName) {
            this.uploadLogItems = []
            this.uploadLogTotalRows = 0
            return
        }

        this.uploadLogLoading = true
        try {
            console.log("Step-1");
            const page = this.uploadLogCurrentPage - 1
            const response = await fetch(
                `/api/integration/dict/log/${apiDictName}?page=${page}&size=${this.uploadLogPerPage}`
            )

            if (response.ok) {
                const data = await response.json()
                this.uploadLogItems = data.content;
                // this.uploadLogItems = this.formatUploadLogItems(data.items || data.content || data || [])
                // this.uploadLogTotalRows = data.totalElements || data.total || (Array.isArray(data) ? data.length : 0)
            } else {
                this.uploadLogItems = []
                this.uploadLogTotalRows = 0
            }
        } catch (error) {
            console.error('Ошибка загрузки журнала загрузок:', error)
            this.uploadLogItems = []
            this.uploadLogTotalRows = 0
        } finally {
            this.uploadLogLoading = false
        }
    }

    formatUploadLogItems(items: any[]) {
        if (!Array.isArray(items)) {
            return []
        }
        return items.map(item => {
            // Обработка нового формата details (объект с summary и changesContent)
            let detailsSummary = null
            let hasChangesContent = false
            let rawDetails = null

            if (item.details) {
                if (typeof item.details === 'object' && item.details.summary) {
                    // Новый формат: { summary: {...}, changesContent: [...] }
                    detailsSummary = item.details.summary
                    hasChangesContent = !!(item.details.changesContent && item.details.changesContent.length > 0)
                    rawDetails = item.details
                } else if (typeof item.details === 'string') {
                    // Старый формат: строка
                    rawDetails = item.details
                }
            }

            return {
                id: item.id || item.loadId || '',
                tableName: item.tableName || item.table_name || 'Visual_gu',
                loadDateTime: this.formatDateTime(item.finishDateTime || item.loadDateTime || item.load_date_time || item.dateTime),
                loadStatus: this.formatLoadStatus(item.status || item.loadStatus || item.load_status),
                user: this.formatUser(item.user || item.userName || item.username),
                details: rawDetails ? (typeof rawDetails === 'string' ? rawDetails : '') : '',
                detailsSummary: detailsSummary,
                hasChangesContent: hasChangesContent,
                rawDetails: rawDetails, // Сохраняем полный объект details для модального окна
                launchType: this.formatLaunchType(item.runType || item.launchType || item.launch_type || item.type)
            }
        })
    }

    formatDateTime(dateTime: any) {
        if (!dateTime) return ''
        if (typeof dateTime === 'number') {
            const date = new Date(dateTime)
            return this.formatDateToDDMMYYYYHHMMSS(date)
        }
        if (typeof dateTime === 'string') {
            const date = new Date(dateTime)
            return this.formatDateToDDMMYYYYHHMMSS(date)
        }
        return dateTime.toString()
    }

    formatDateToDDMMYYYYHHMMSS(date: Date) {
        if (!date || isNaN(date.getTime())) return ''
        const day = String(date.getDate()).padStart(2, '0')
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const year = date.getFullYear()
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        const seconds = String(date.getSeconds()).padStart(2, '0')
        return `${day}.${month}.${year}, ${hours}:${minutes}:${seconds}`
    }

    formatLoadStatus(status: any) {
        if (!status) return ''
        const statusLower = String(status).toLowerCase()
        if (statusLower.includes('ошибка') || statusLower.includes('error')) {
            return 'Ошибка'
        }
        if (statusLower.includes('не требуется') || statusLower.includes('not required')) {
            return 'Обновление не требуется'
        }
        return 'Данные обновлены'
    }

    formatUser(user: any) {
        if (!user || String(user).toLowerCase().includes('auto') || String(user).toLowerCase().includes('авто')) {
            return 'Автозагрузка'
        }
        return user
    }

    formatLaunchType(type: any) {
        if (!type) return ''
        const typeLower = String(type).toLowerCase()
        if (typeLower.includes('auto') || typeLower.includes('авто')) {
            return 'Авто'
        }
        return 'Ручное'
    }

    showLogDetails(item: any) {
        this.logDetailsData = null
        this.logDetailsLoading = false

        if (item.rawDetails && item.rawDetails.changesContent) {
            // Если данные уже есть в объекте
            this.logDetailsData = {
                detailsSummary: item.rawDetails.summary,
                changesContent: item.rawDetails.changesContent,
                truncated: item.rawDetails.truncated || false,
                totalChangesCount: item.rawDetails.totalChangesCount || item.rawDetails.changesContent.length,
                error: item.rawDetails.error || null
            }
            this.showLogDetailsModal = true
        } else if (item.id) {
            // Если нужно загрузить детали через отдельный эндпоинт
            this.loadLogDetails(item.id)
        } else {
            // Fallback на старый формат
            this.logDetailsData = {
                error: item.details || 'Детализация недоступна'
            }
            this.showLogDetailsModal = true
        }
    }

    async loadLogDetails(logId: any) {
        this.logDetailsLoading = true
        this.showLogDetailsModal = true

        const apiDictName = this.getDictApiName(this.selectedDict);
        if (!apiDictName) {
            this.logDetailsData = {
                error: 'Не удалось определить справочник для загрузки деталей'
            };
            this.logDetailsLoading = false;
            return;
        }

        try {
            const response = await fetch(`/api/integration/dict/log/${apiDictName}/${logId}/details`)
            if (response.ok) {
                const data = await response.json()
                this.logDetailsData = {
                    detailsSummary: data.summary,
                    changesContent: data.changesContent || [],
                    truncated: data.truncated || false,
                    totalChangesCount: data.totalChangesCount || (data.changesContent ? data.changesContent.length : 0),
                    error: data.error || null
                }
            } else {
                this.logDetailsData = {
                    error: `Ошибка загрузки деталей: ${response.status} ${response.statusText}`
                }
            }
        } catch (error) {
            console.error('Ошибка загрузки деталей журнала:', error)
            this.logDetailsData = {
                error: `Ошибка загрузки деталей: ${error.message}`
            }
        } finally {
            this.logDetailsLoading = false
        }
    }

    resetLogDetails() {
        this.showLogDetailsModal = false
        this.logDetailsData = null
        this.logDetailsLoading = false
    }

    formatChangesContent(changesContent: any[]) {
        if (!Array.isArray(changesContent)) {
            return []
        }

        const result: any[] = []

        changesContent.forEach((change, index) => {
            const changeType = (change.changeType || '').toUpperCase()

            if (changeType === 'UPDATE' && change.changes) {
                // Для UPDATE разворачиваем changes в отдельные строки
                Object.keys(change.changes).forEach(field => {
                    const changeValue = change.changes[field]
                    result.push({
                        changeType: changeType,
                        code: change.values?.code || change.values?.id || '',
                        field: field,
                        oldValue: changeValue.oldValue,
                        newValue: changeValue.newValue
                    })
                })
            } else if (changeType === 'INSERT') {
                // Для INSERT показываем значения из values
                if (change.values && typeof change.values === 'object') {
                    Object.keys(change.values).forEach(field => {
                        result.push({
                            changeType: changeType,
                            code: change.values?.code || change.values?.id || '',
                            field: field,
                            oldValue: '',
                            newValue: change.values[field]
                        })
                    })
                } else {
                    result.push({
                        changeType: changeType,
                        code: change.values?.code || change.values?.id || '',
                        field: 'Новая запись',
                        oldValue: '',
                        newValue: change.values ? JSON.stringify(change.values) : ''
                    })
                }
            } else if (changeType === 'DELETE') {
                // Для DELETE показываем значения из values
                if (change.values && typeof change.values === 'object') {
                    Object.keys(change.values).forEach(field => {
                        result.push({
                            changeType: changeType,
                            code: change.values?.code || change.values?.id || '',
                            field: field,
                            oldValue: change.values[field],
                            newValue: ''
                        })
                    })
                } else {
                    result.push({
                        changeType: changeType,
                        code: change.values?.code || change.values?.id || '',
                        field: 'Удаленная запись',
                        oldValue: change.values ? JSON.stringify(change.values) : '',
                        newValue: ''
                    })
                }
            }
        })

        return result
    }

    formatChangeType(changeType: any) {
        const type = (changeType || '').toUpperCase()
        const map = {
            'INSERT': 'Добавление',
            'UPDATE': 'Обновление',
            'DELETE': 'Удаление'
        }
        return map[type as keyof typeof map] || changeType
    }

    getChangeTypeClass(changeType: any) {
        const type = (changeType || '').toUpperCase()
        if (type === 'INSERT') return 'text-success'
        if (type === 'UPDATE') return 'text-warning'
        if (type === 'DELETE') return 'text-danger'
        return ''
    }

    formatChangeValue(value: any) {
        if (value === null || value === undefined) {
            return '<пусто>'
        }
        if (typeof value === 'object') {
            return JSON.stringify(value)
        }
        if (typeof value === 'number' && value > 1000000000000) {
            // Вероятно, это timestamp
            const date = new Date(value)
            if (!isNaN(date.getTime())) {
                return this.formatDateToDDMMYYYYHHMMSS(date)
            }
        }
        return String(value)
    }

    handleUploadLogPageChange(page: number) {
        this.uploadLogCurrentPage = page
        this.loadUploadLog()
    }

    getStatusStyle(status: string) {
        if (status === 'Ошибка') {
            return 'color: #dc3545; font-weight: 500;'
        }
        if (status === 'Обновление не требуется') {
            return 'color: #6c757d;'
        }
        return 'color: #28a745; font-weight: 500;'
    }

    formatModifStat(detail: string) {
        if (!detail || typeof detail !== 'string') {
            return detail
        }

        // Парсим строку вида "ModifStat(inserted=0, deleted=0, updated=2)"
        const regex = /ModifStat\s*\(\s*inserted\s*=\s*(\d+)\s*,\s*deleted\s*=\s*(\d+)\s*,\s*updated\s*=\s*(\d+)\s*\)/i
        const match = detail.match(regex)

        if (match) {
            const inserted = match[1]
            const deleted = match[2]
            const updated = match[3]
            return `Добавлено = ${inserted}, Удалено = ${deleted}, Обновлено = ${updated}`
        }

        // Если не соответствует формату, возвращаем как есть
        return detail
    }
}
